import { observable, computed, runInAction } from 'mobx';
import _ from 'lodash';

export default class FilterOptions {
    @observable sortOrder = [];
    @observable sortName = [];
    @observable sort = [];
    @observable skip = '';
    @observable limit = '';
    @observable agentContactIds = [];
    @observable coordinatorIds = [];
    @observable pageSize = 25;
    @observable currentPage = 1;
    filters = observable.map();

    constructor() {}

    @computed
    get sortNameArray() {
        return this.sortName.slice();
    }

    @computed
    get sortOrderArray() {
        return this.sortOrder.slice();
    }

    @computed
    get filtersKP() {
        return this.filters.entries().map(x => {
            return { key: x[0], value: `${x[1].type} : ${x[1].label}` };
        });
    }

    @computed
    get filter() {
        const _sortNameArray = _.clone(this.sortNameArray.slice());
        const filter = { customFilters: [] };

        if (this.sortNameArray.length > 0) {
            filter.order = _sortNameArray.reverse().map((field, i) => {
                return field + ' ' + this.sortOrderArray[i];
            });
        }

        this.filters.forEach(f => {
            filter.customFilters.push(f);
        });
        filter.limit = this.pageSize;
        filter.skip = (this.currentPage - 1) * this.pageSize;

        return filter;
    }

    setSort(name, order) {
        runInAction(() => {
            let sortName = this.sortName.slice(),
                sortOrder = this.sortOrder.slice();
            // console.log("name", sortName)
            // console.log("order", sortOrder)
            const sortIndex = sortName.indexOf(name);
            if (sortIndex >= 0) {
                sortName.splice(sortIndex, 1);
                sortOrder.splice(sortIndex, 1);
                if (order !== 'desc') {
                    sortName.push(name);
                    sortOrder.push(order);
                }
            } else {
                sortName.push(name);
                sortOrder.push(order);
            }
            this.sortName.replace(sortName);
            this.sortOrder.replace(sortOrder);
        });
    }
}



// WEBPACK FOOTER //
// ./src/shared/filter-options.js